(function(){

  'use strict'

  angular
    .module('app')
    .controller('MainController', MainController)
    .controller('SliderController', SliderController)
    .controller('ContattiController', ContattiController)
    .controller('ParlanoDiNoiController', ParlanoDiNoiController)
    .controller('PhotoController', PhotoController)
  ;

  ////////////////////////////

  function MainController($scope, $window, $timeout){
    var c = this;

    angular
      .element($window)
      .on('load', onLoad)
    ;

    return c;

    ////////////////////////////

    function onLoad(){
      $timeout(function(){
        document.body.className += ' load';
      }, 0);
    }
  }

  MainController.$inject = ['$scope', '$window', '$timeout'];

  ////////////////////////////

  SliderController.$inject = ['$scope', '$interval', '$timeout'];

  function SliderController($scope, $interval, $timeout){
    var c = this;

    $scope.active = 0;
    $scope.slideLeft = 0;

    var slider = {
      count   : 3,
      timing  : 6000,
      current : 0,
      element : document.getElementById('slider')
    }

    $interval(changeSlide, slider.timing);

    return c;

    ////////////////////////////

    function changeSlide(){
      slider.current++;
      slider.element.style.opacity = 0;

      $timeout(function(){
        $scope.slideLeft = slider.element.offsetWidth * (slider.current % slider.count);
        $timeout(function(){ slider.element.style.opacity = 1; });
      }, 1200);
    }
  }

  ////////////////////////////


  function ContattiController($scope, $http, $sce, $timeout){
    var inT = false, c = this;

    $scope.contatti = { };

    c.send = send;

    return c;

    ////////////////////////////

    function send()
    {
      if(!inT){
        inT = true;
        $http.post('sendMail', $scope.contatti)
          .then(successCallback, errorCallback);
      }
    }

    function successCallback(d)
    {
      $scope.result = { ok: $sce.trustAsHtml('<b style="color: #0ac881">' + d.data.flash + '</b>') };
      $timeout(function(){ inT = false; }, 3000);
      $timeout(function(){ $scope.result = {} }, 5000);
    }

    function errorCallback(d)
    {
      console.log(d);
      if(d.status == 500){
        $scope.result = { no: $sce.trustAsHtml('<span style="font-size: 12px; line-height: 14px;">Impossibile completare l\'operazione. <a class="link" target="_blank" href="mailto:info@ortodonziainvisibile.org">Clicca qui</a> per inviare l\'email esternamente.</span>') };
        return;
      }
      $scope.result = { no: null };

      var r = '<ul class="mg-0 pd-0 t-r" style="list-style:none; line-height:14px; font-size:10px; color:#c22;">', i, j;
      for(i in d.data){
        r += '<li><b>' + i + '</b>: '
        for(j in d.data[i])
          r += j == 0 ? d.data[i][j] : ' | ' + d.data[i][j];
        r += '</li>'
      }
      r += '</ul>'
      $scope.result.no = $sce.trustAsHtml(r);
      $timeout(function(){ $scope.result = {} }, 5000);
      inT = false;
    }

  }

  ContattiController.$inject = ['$scope', '$http', '$sce', '$timeout'];

  ////////////////////////////


  function ParlanoDiNoiController($scope, $riviste, $pubblicazioni, $window, $timeout, $animate)
  {

    var r,c = this;

    $scope.riviste = $riviste;
    $scope.pubblicazioni = $pubblicazioni;

    for(r in $scope.riviste)
      $animate.enabled(document.getElementById('rivista_' + $scope.riviste[r].title), false);

    c.openRivista = openRivista;

    angular.element($window).on('resize', function(){ open($scope.selected); });

    return c;

    ////////////////////////////

    function openRivista(event, rivista, t)
    {
      if(!!event)
        if(event.target.className.indexOf('arrow') >= 0 || event.target.className.indexOf('m-s-p') >= 0) return;

      if(rivista.selected){
        resetStyle(rivista);
        $scope.selected = null;
        return;
      }

      var r;

      for(r in $scope.riviste){
        var f = $scope.riviste[r];
        if(f.title != rivista.title && r != 'default'){
          resetStyle(f);
        }
      }
      for(r in $scope.pubblicazioni){
        var f = $scope.pubblicazioni[r];
        if(f.title != rivista.title && r != 'default'){
          resetStyle(f);
        }
      }

      open(rivista);
    }

    function open(rivista)
    {
      if(!rivista) return;

      var e = document.getElementById('rivista_' + rivista.title),
          o = offset(e.parentNode),
          size = getMaxSize($riviste.default.width, $riviste.default.height + 69);

      $timeout(function(){
        setStyle(e, { left: o.left + 'px', top: o.top + 'px', margin:'', zIndex: 10000 });
        rivista.width = size.width;
        rivista.height = size.height;

        $timeout(function(){
          rivista.selected = true;
          e.getElementsByClassName('arrows')[0].classList.add('open');

          $timeout(function(){
            setStyle(e, {
              top : '50%',
              left : '50%',
              marginLeft : -(size.width / 2) + 'px',
              marginTop : -(size.height / 2) + 'px',
              width : size.width + 'px',
              height : size.height + 'px',
            });
          }, 33);
        },33);
      },33);

      $scope.selected = rivista;

    }

    function resetStyle(f)
    {
      if(!f.selected) return;

      var e = document.getElementById('rivista_' + f.title), o = offset(e.parentNode);
      console.log(f.title, e.parentNode);
      f.width = $riviste.default.width;
      f.height = $riviste.default.height;

      setStyle(e, {
        zIndex: 0,
        width: $riviste.default.width + 'px',
        height: ($riviste.default.height + 69) + 'px',
        top: o.top + 'px', left: o.left + 'px', marginLeft: '0px', marginTop: '0px'
      });
      e.getElementsByClassName('arrows')[0].classList.remove('open');

      $timeout(function(){
        f.selected = false;
        setStyle(e, {
          top: '0px', left: '0px'
        });
      }, 600);
    }

    function setStyle(e, s)
    {
      var p;
      for(p in s){
        e.style[p] = s[p];
      }

    }

    function getMaxSize(w, h){
      var MAX_WIDTH = $window.innerWidth - 40;
      var MAX_HEIGHT = $window.innerHeight - 40;

      var size = { width : MAX_WIDTH, height : MAX_HEIGHT };

      do {
        if(size.width > MAX_WIDTH || size.height > MAX_HEIGHT)
          size = resize(size.height, size.width, w, h);
        else
          size = resize(size.width, size.height, w, h);
      } while(size.width > MAX_WIDTH || size.height > MAX_HEIGHT);

      return size;
    }

    function resize(dw, dh, w, h){
      var nw, nh, rw, rh;

      rh = h / w;  rw = w / h;

      if(h > w){
        rh = h / w;
        rw = w / h;
        nh = dh;
        nw = rw * nh
      } else {
        rw = w / h;
        rh = h / w;
        nw = dw;
        nh = rh * nw
      }
      return { width: nw, height: nh };
    }

    function offset(el){
      var _x = 0;
      var _y = 0;

      while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
          _x += el.offsetLeft - el.scrollLeft;
          _y += el.offsetTop - el.scrollTop;
          el = el.offsetParent;
      }
      return { top: _y, left: _x };
    }

  }

  ParlanoDiNoiController.$inject = ['$scope', 'RivisteFactory', 'PublicazioniScientificheFactory', '$window', '$timeout', '$animate'];

  ////////////////////////////

  function PhotoController($scope, $timeout, $window)
  {
    var c = this, iA = false, ci = -1, congressi = document.getElementsByClassName('cliccable-photo');

    c.open = open;

    angular
      .element($window)
      .on('click', function(e){
        if(e.target.className.indexOf('cliccable-photo') < 0)
          resetStyle(-1, true);
      })
      .on('keydown', function(e){
        if(e.keyCode == 27)
          resetStyle(-1, true);
      });

    return c;

    ////////////////////////////

    function open(event, i)
    {
      console.log(event, i, congressi);
      if(iA) return;

      iA = true;

      if(i == ci){
        resetStyle(i, true);
        $timeout(function(){
           ci = -1;
           iA = false;
        }, 300);
        return;
      }


      resetStyle(i);
      var e = congressi[i],
          o = offset(e.parentNode),
          s = Math.min($window.innerWidth, $window.innerHeight) - 40;


      $timeout(function(){
        setStyle(e, { position: 'fixed', left: o.left + 'px', top: o.top + 'px', margin:'', zIndex: 10000 });
        e.style.width = s;
        e.style.height = s;

        $timeout(function(){
          e.classList.add('open');

          $timeout(function(){
            setStyle(e, {
              top : '50%',
              left : '50%',
              marginLeft : -(s / 2) + 'px',
              marginTop : -(s / 2) + 'px',
              width : s + 'px',
              height : s + 'px'
            });

            iA = false;
          }, 33);
        },33);
      },33);

      ci = i;
    }

    function resetStyle(i, t)
    {
      var c, o;
      for(c in congressi){
        if(c == i && !t) continue;
        var v = congressi[c];
        o = offset(v.parentNode);
        if(v.nodeType){
          setStyle(v, {
            zIndex: 0,
            width: v.parentNode.offsetWidth + 'px',
            height: v.parentNode.offsetWidth + 'px',
            margin: '0', top: o.top + 'px', left: o.left + 'px'
          });
          removeClass(v);
        }
      }
    }

    function removeClass(e){
     $timeout(function(){
        setStyle(e, { position: 'static' });
        e.classList.remove('open');
      }, 300);
    }

    function setStyle(e, s)
    {
      var p;
      for(p in s){
        e.style[p] = s[p];
      }
    }

    function offset(el){
      var _x = 0;
      var _y = 0;

      while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
          _x += el.offsetLeft - el.scrollLeft;
          _y += el.offsetTop - el.scrollTop;
          el = el.offsetParent;
      }
      return { top: _y, left: _x };
    }
  }

  PhotoController.$inject = ['$scope', '$timeout', '$window'];

})();
